module.exports = __webpack_public_path__ + "static/media/coalesse-5.315ea6f9.jpg";